import type { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { SSEProvider } from '@/contexts/SSEContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

interface Props {
  children: ReactNode
}

export function Providers({ children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <SSEProvider>
        {children}
        {/* ph-mask : les toasts répètent parfois un courriel saisi (invitations). */}
        <Toaster className="ph-mask" position="top-right" richColors closeButton />
      </SSEProvider>
    </QueryClientProvider>
  )
}
